//const BaseUrl = process.env.VUE_APP_API_BASEURL;
const BaseUrl = process.env.VUE_APP_API_BASEURL_LIVE;

const HandlerState = {};

import store from "./store";
import products from "./products";

async function form(path, data, errors) {
    try {
        return await api(path, data);
    } catch (ex) {
        if (ex.status === 400)
            errors.push(...ex.json.errors);
        else
            errors.push("Unknown error.");
    }
}

async function api(path, data) {
    return await innerApi();

    async function innerApi() {
        let headers = {
            "Content-Type": "application/json"
        };
        
        if (store.state.id)
            headers["Authorization"] = "Bearer " + store.state.id.token;
        
        let resp = await fetch(BaseUrl + path, {
            method: "POST",
            mode: "cors",
            headers: headers,
            body: JSON.stringify(data || {}),
        });

        if (resp.status === 200)
            return await resp.json();
    
        let handlers = HandlerState[resp.status] || [];
    
        for (var h of handlers)
            await h(resp);

        throw {
            message: "http.error",
            status: resp.status,
            json: await resp.json()
        };
    }
}

async function ping() {
    return (await api("/ping") !== null);
}

async function reauth() {
    if (store.state.authed || !store.state.id.token)
        return;

    return await auth();
}

async function auth(email, password) {
    let data = {
        "email": email,
        "password": password
    };

    let result = null;

    try {
        result = await api("/auth", data);
    }
    // eslint-disable-next-line no-empty
    catch { }

    if (result) {
        store.commit("auth", result);

        await products.refresh();

        return true;
    }

    return false;
}

function handle(code, callback) {
    HandlerState[code] = HandlerState[code] || [];
    HandlerState[code].push(callback);
}

export { auth, api, ping, handle, reauth, form };